import { environment } from "src/environments/environment";

export const APP_VERSION = '1.1.10.0' + '.' + environment.tag;
